var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-05
 * @brief SEI 햄버거 메뉴 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { langId, langState } from "../../../recoil/langState";
import { detailHistory, detailList, loadingBoxState, marketWork, menuListState, menuState, parentCode, urlState, } from "../../../recoil/menuState";
import { demo, userInfoLoginState, userInfoState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as USERUTIL from "../../../utils/user/userUtils";
//ex-utils
import * as i18n from "../../../utils/langs/i18nUtils";
import { adminTabState, noneUrl } from "../../../recoil/assessmentState";
import { useTrans } from "../../../utils/langs/useTrans";
function SideBar(props) {
    // trans, navigate, ref
    const navigate = useNavigate();
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [menuRecoilList, setRecoilMenuList] = useRecoilState(menuListState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const [hbMenuToggle, setRecoilHbMenuToggle] = useRecoilState(menuState);
    const setRecoilMenuCode = useSetRecoilState(parentCode);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const setRecoilMarkerWorks = useSetRecoilState(marketWork);
    const setRecoilHistory = useSetRecoilState(detailHistory);
    const setRecoilDetailList = useSetRecoilState(detailList);
    const demos = useRecoilValue(demo);
    const setRecoilUserInfo = useSetRecoilState(userInfoState);
    const setRecoilUrl = useSetRecoilState(urlState);
    const setRecoilTab = useSetRecoilState(adminTabState);
    const setRecoilLangIds = useSetRecoilState(langId);
    // props
    const isWindow = props.isWindow; // header에서 tag size로 모바일 여부를 체크함
    const [selMenu, setSelMenu] = useState(null);
    const [menuList, setMenuList] = useState([]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/menus/role`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langs,
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            if (retData.codeNum == CONST.API_200) {
                sessionStorage.setItem(CONST.STR_EHP_MENULIST, JSON.stringify(retData.body)); // 특정 화면에서 url로 menu 정보 추출하기 위함
                setRecoilMenuList(retData.body);
                setMenuList(retData.body);
                if (demos) {
                    setRecoilMenuList(retData.body.filter((menu) => menu.url !== CONST.URL_OPERATION));
                    setMenuList(retData.body.filter((menu) => menu.url !== CONST.URL_OPERATION));
                }
                else {
                    setRecoilMenuList(retData.body);
                    setMenuList(retData.body);
                }
            }
        }
    }, [retData]);
    function onClickGoPage(url) {
        // 페이지 이동
        navigate(url);
        setRecoilHbMenuToggle(false);
    }
    function onClickGoMenu(e, menu) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (menu.isExternalUrl) {
                window.open(menu.url, "_blank", "noreferrer");
                return;
            }
            var url = CUTIL.isnull(menu.url) ? CONST.URL_SYSTEM_ERROR : menu.url;
            // menu code 선택
            setRecoilMenuCode(menu.parentCode);
            // Url 이동
            setRecoilTab("SITE");
            setRecoilNoneUrlInfo(false);
            setRecoilUrlInfo(url);
            onClickGoPage(url);
            if (menu.parentCode == "MENU6") {
                location.reload();
            }
            const detailUserInfo = yield USERUTIL.getDetailUserInfoR(userInfo.loginInfo);
            if (localStorage.getItem("langs") !== detailUserInfo.language) {
                location.reload();
            }
            /* 화면 이동 에러시 위 코드와 변경 필요
            const frontLangs = CUTIL.frontLangSet(detailUserInfo.language);
            if (localStorage.getItem("langs") !== frontLangs) {
              location.reload();
            } */
        });
    }
    function menuOnClick(e, menu) {
        if (selMenu) {
            if (selMenu.menuCode === menu.menuCode) {
                setSelMenu(null);
            }
            else {
                setSelMenu(menu);
            }
        }
        else {
            setSelMenu(menu);
        }
    }
    function navbarOnClick(e) {
        setRecoilHbMenuToggle(!hbMenuToggle);
    }
    function onClickGoMarket(e) {
        return __awaiter(this, void 0, void 0, function* () {
            //Url 이동
            setRecoilNoneUrlInfo(false);
            setRecoilMarkerWorks("LIST");
            setRecoilHistory({
                page: 0,
                bigGroup: "energy",
                searchKind: 0,
                searchLike: "",
                tagSearch: [],
                searchFilter: "",
                zone: false,
                zoneId: null,
            });
            setRecoilDetailList(null);
            const detailUserInfo = yield USERUTIL.getDetailUserInfoR(userInfo.loginInfo);
            const apiLang = CUTIL.frontLangSet(detailUserInfo.language);
            if (localStorage.getItem("langs") !== apiLang) {
                setRecoilUserInfo(Object.assign(Object.assign({}, userInfo), { 
                    // loginTime: detailUserInfo.loginTime,
                    // userId: detailUserInfo.userId,
                    // email: detailUserInfo.email,
                    // userName: detailUserInfo.userName,
                    // phoneNumber: detailUserInfo.phoneNumber,
                    // companyName: detailUserInfo.companyName,
                    // zoneName: detailUserInfo.zoneName,
                    // department: detailUserInfo.department,
                    // role: detailUserInfo.role,
                    language: detailUserInfo.language }));
                const params = new URLSearchParams(location.search);
                const paramsLagns = params.get("lang");
                // let language = (localStorage.getItem(CONST.STR_LANG_I18N) == CONST.STR_LANG_KOR) ? CONST.STR_APILANG_KOR : CONST.STR_APILANG_ENG
                const frontLang = CUTIL.frontLangSet(detailUserInfo.language);
                const langId = CUTIL.LangIdSet(frontLang);
                localStorage.setItem("langId", langId.toString());
                // let language =  CONST.STR_APILANG_KOR
                // const frontLang = CUTIL.frontLangSet(language);
                yield i18n.changeLang(frontLang);
                setRecoilLangIds(langId);
                setRecoilLangs(frontLang);
            }
            setRecoilUrlInfo(CONST.URL_MARKETPLACE);
            onClickGoPage(CONST.URL_MARKETPLACE);
            localStorage.setItem("loginintro", CONST.URL_MARKETPLACE);
            if (localStorage.getItem("langs") == apiLang) {
                location.reload();
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsx("nav", Object.assign({ className: `navbar ${hbMenuToggle ? "active" : ""}`, onClick: (e) => navbarOnClick(e) }, { children: _jsxs("ul", Object.assign({ className: `navbar__menu ${userInfo.loginInfo.role == CONST.USERROLE_NONE ? "nook-user" : ""}`, onClick: (e) => e.stopPropagation() }, { children: [menuList
                        .filter((menu) => CUTIL.isnull(menu.parentCode))
                        .map((menu, midx) => (isWindow ? true : menu.isMobile) && (_jsx("li", Object.assign({ onClick: (e) => menuOnClick(e, menu), className: selMenu && menu.menuCode === selMenu.menuCode ? "active" : "" }, { children: menuList.filter((m) => m.parentCode === menu.menuCode).length <= 0 ? (_jsx("a", Object.assign({ href: "#", onClick: (e) => onClickGoMenu(e, menu) }, { children: menu.menuName }))) : (_jsxs(_Fragment, { children: [_jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: menu.menuName })), _jsx("ul", { children: menuList
                                        .filter((m) => m.parentCode === menu.menuCode)
                                        .map((smenu, sidx) => (isWindow ? true : smenu.isMobile) && (_jsx("li", Object.assign({ onClick: (e) => onClickGoMenu(e, smenu) }, { children: _jsx("a", Object.assign({ onClick: (e) => onClickGoMenu(e, smenu) }, { children: smenu.menuName })) }), `smemnu_${sidx.toString()}`))) })] })) }), `mmenu_${midx.toString()}`))), _jsx("li", Object.assign({ className: "btn-area" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-darkgray", onClick: (e) => onClickGoMarket(e) }, { children: _jsx("span", Object.assign({ className: "icon-go" }, { children: t("라벨.MarketPlace이동") })) })) }))] })) })) }));
}
export default SideBar;
